var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmileyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5a10.5 10.5 0 110-21 10.5 10.5 0 010 21zm0 1.5a12 12 0 100-24 12 12 0 000 24z",
    fill: "#A28D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.428 14.35a.75.75 0 011.024.275A5.247 5.247 0 0012 17.25a5.248 5.248 0 004.548-2.625.75.75 0 111.3.75A6.747 6.747 0 0112 18.75a6.747 6.747 0 01-5.847-3.375.75.75 0 01.275-1.024zm4.072-4.6C10.5 10.992 9.828 12 9 12s-1.5-1.008-1.5-2.25S8.172 7.5 9 7.5s1.5 1.008 1.5 2.25zm6 0c0 1.242-.672 2.25-1.5 2.25s-1.5-1.008-1.5-2.25.672-2.25 1.5-2.25 1.5 1.008 1.5 2.25z",
    fill: "#A28D50"
  })));
}

export default SvgSmileyIcon;